import { render, staticRenderFns } from "./ImportChooseMethod.vue?vue&type=template&id=49d634da&scoped=true&"
import script from "./ImportChooseMethod.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ImportChooseMethod.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ImportChooseMethod.vue?vue&type=style&index=0&id=49d634da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d634da",
  null
  
)

export default component.exports